import * as React from 'react';
import './ReleaseNotes.css';

const releases = [
  {
    version: "",
    date: 'May, 2026',
    latest: true,
    changes: {
      'Search': [
        'Suggested keywords are now available if your query is short.'
      ],
    },
  },
  {
    version: "",
    date: 'April, 2026',
    changes: {
      'Partner search': [
        'New partner search algorithm has been introduced providing better performance and results'
      ],
      'Projects and partners': [
        'New data sources have been introduced (incl. FP7 projects)'
      ],
      'Projects': ['Project acronyms have been made visible in more places'],
      'Information': ['Info icons have been added and updated'],
    },
  },
  {
    version: "",
    date: 'March, 2026',
    changes: {
      'Projects': [
        'Added projects from Funding and Tenders portal',
        'Added project categorisation per European Science Vocabulary (https://op.europa.eu/en/web/eu-vocabularies/euroscivoc ).',
        'Fixed bugs on not all projects showing correctly',
        'Made project acronyms visible'
      ],
      'Partners': [
        'Added 7000 new partner profiles to database from new projects',
        'Fixed bugs on not all partners showing correctly'
      ],
      'Funding': ['Added AI summaries for all open and forthcoming topics'],
    },
  },
  {
    version: "",
    date: 'February, 2026',
    changes: {
      'Partner Profile': [
        'Bug fix and improvements',
      ],
      'Partner search improvement preparation': [
        'Indexing of new partner data',
      ],
      'Excel export': ['Added Expected contribution and Indicative number of grants to the exports'],
    },
  },
  {
    version: "",
    date: 'January, 2026',
    changes: {
      'About Page': [
        'Added release notes',
      ],
      'Organization Profile Page': [
        'Filtering, sorting and search added for projects',
      ],
      'Analytics': ['Export of topic description is now in plain text (and not in html)'],
    },
  },
  {
    version: "",
    date: 'December, 2025',
    changes: {
      'About page': [
        'Added a new page with database size',
      ],
    },
  },
  {
    version: "",
    date: 'November, 2025',
    changes: {
      'Organisation profile page': [
        'Added a profile page for all organisations',
        'List of project the organisation has participated',
        'List of collaborations the organisation has had'
      ],
      'Miscellaneous': [
        'Bug fixes and minor improvements',
      ],
    },
  },
  {
    version: "",
    date: 'October, 2025',
    changes: {
      'Project profiles': [
        'Bug fixes and minor improvements',
      ],
    },
  },
  {
    version: "",
    date: 'September, 2025',
    changes: {
      'Funding and partner data': [
        'Bug fixes and minor improvements',
      ],
    },
  },
  {
    version: "",
    date: 'August, 2025',
    changes: {
      'Improved budget information': [
        'Budget information is now shown in a more granular way together with the expected number of projects to be funded and indicative grant size.',
      ],
      'Info texts': ['Improved descriptions'],
      'UI': ['Bug fixes and minor improvements']
    },
  },
  {
    version: "",
    date: 'July, 2025',
    changes: {
      'Email service': [
        'Bug fixes and minor improvements',
      ],
    },
  },
  {
    version: "",
    date: 'June, 2025',
    changes: {
      'New data analytics feature': [
        'User can export calls to excel for further analysis.',
      ],
      'Miscellaneous': [
        'Bug fixes and improvements',
      ],
    },
  },
  {
    version: "",
    date: 'May, 2025',
    changes: {
      'Improved project and partner search algorithms': [
        'Interactive analytics dashboard with customizable widgetsNew state of the art algorithm and reindexed database to improve the search results',
        'Bulk import functionality for funding call dataMultilanguage search',
      ],
      'Project profile': [
        'Added a link to visit project website',
      ],
      'Project data': [
        'Included new types of projects from Cordis to database'
      ]
    },
  },
  {
    version: "",
    date: 'April, 2025',
    changes: {
      'New funding search algorithm': [
        'New state of the art algorithm and reindexed database to improve the search results',
        'Multilanguage search',
      ],
    },
  },
];

const ReleaseNotesPage: React.FC = () => {
  return (
    <section className="releases">
      <div className="releases-header">
        <h2>Release Notes</h2>
        {/* <div className="release-filters">
          <button className="btn btn-primary">All Releases</button>
        </div> */}
      </div>

      <div className="timeline">
        {releases.map((release, idx) => (
          <div key={idx} className={`timeline-item ${idx % 2 === 0 ? 'right' : 'left'}`}>
            <div className="timeline-dot" />

            <div className="release-card">
              <div className="release-header">
                <div>
                  <div className="release-version">{release.version}</div>
                  {release.latest && <span className="badge">Latest</span>}
                </div>
                <div className="release-date">{release.date}</div>
              </div>

              {Object.entries(release.changes).map(([category, items]) => (
                <div key={category} className="release-section">
                  <div className="release-category">{category}</div>
                  <ul>
                    {items.map((item: any, i: any) => (
                      <li key={i}>{item}</li>
                    ))}
                  </ul>
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export const ReleaseNotes = ReleaseNotesPage;
